import { MouseEventHandler } from "react";
import { IconProps } from "@mui/material";

import {
  ActionAddShrap,
  ActionLogin,
  ActionTransfer,
  AlertTriangle,
  BellIcon,
  BidIcon,
  CalendarIcon,
  CurrencyMarks,
  CurrencyPrime,
  CurrencyShrap,
  CurrencySigma,
  CheckmarkIcon,
  CloseIcon,
  Collect,
  CompleteHexIcon,
  CompleteIcon,
  Deposit,
  DepositShrapIcon,
  DownArrowIcon,
  EditIcon,
  Elimination,
  Experience,
  Explosive,
  FailedIcon,
  Headshot,
  InventoryIcon,
  IconMenu,
  Loss,
  SearchIcon,
  KebabIcon,
  LeftArrow,
  MedKit,
  MetalIcon,
  MinusIcon,
  PlusIcon,
  RadioIcon,
  RadioCheckedIcon,
  RemixIcon,
  ReportIcon,
  Running,
  SaveIcon,
  SandClock,
  SellIcon,
  SettingsIcon,
  ShareIcon,
  SmallDownArrowIcon,
  SortIcon,
  SupplyIcon,
  TagEcho,
  TagOperator,
  TransferIcon,
  TransactionAirdropped,
  TransactionCreated,
  TransactionExtracted,
  TransactionGame,
  TransactionLost,
  TransactionPurchase,
  TransactionSold,
  TransactionTransferIn,
  TransactionTransferOut,
  TransactionWallet,
  TransactionPayment,
  UpsideDownStar,
  Versus,
  Win,
  WithdrawShrapIcon,
  ZoomInIcon,
} from "../../assets/icons";

import { GroupIcon } from "../../assets/icons/group-icon";

export const ComponentMapping = {
  "alert-triangle": AlertTriangle,
  bell: BellIcon,
  bid: BidIcon,
  calendar: CalendarIcon,
  checkmark: CheckmarkIcon,
  close: CloseIcon,
  collect: Collect,
  "complete-hex": CompleteHexIcon,
  complete: CompleteIcon,
  currencyMarks: CurrencyMarks,
  currencyPrime: CurrencyPrime,
  currencyShrap: CurrencyShrap,
  currencySigma: CurrencySigma,
  deposit: Deposit,
  depositShrap: DepositShrapIcon,
  "down-arrow": DownArrowIcon,
  elimination: Elimination,
  experience: Experience,
  explosive: Explosive,
  failed: FailedIcon,
  headshot: Headshot,
  inventory: InventoryIcon,
  kebab: KebabIcon,
  group: GroupIcon,
  "left-arrow": LeftArrow,
  loss: Loss,
  menu: IconMenu,
  "med-kit": MedKit,
  metal: MetalIcon,
  minus: MinusIcon,
  plus: PlusIcon,
  radio: RadioIcon,
  radioChecked: RadioCheckedIcon,
  remix: RemixIcon,
  report: ReportIcon,
  running: Running,
  "sand-clock": SandClock,
  search: SearchIcon,
  sell: SellIcon,
  settings: SettingsIcon,
  share: ShareIcon,
  "small-down-arrow": SmallDownArrowIcon,
  sort: SortIcon,
  supply: SupplyIcon,
  "tag-operator": TagOperator,
  "tag-echo": TagEcho,
  transfer: TransferIcon,
  save: SaveIcon,
  edit: EditIcon,
  addShrap: ActionAddShrap,
  login: ActionLogin,
  transferShrap: ActionTransfer,
  "transaction-airdropped": TransactionAirdropped,
  "transaction-created": TransactionCreated,
  "transaction-extracted": TransactionExtracted,
  "transaction-game": TransactionGame,
  "transaction-inventory": InventoryIcon,
  "transaction-lost": TransactionLost,
  "transaction-purchase": TransactionPurchase,
  "transaction-sold": TransactionSold,
  "transaction-transfer-in": TransactionTransferIn,
  "transaction-transfer-out": TransactionTransferOut,
  "transaction-wallet": TransactionWallet,
  "transaction-payment": TransactionPayment,
  "upside-down-star": UpsideDownStar,
  versus: Versus,
  withdrawShrap: WithdrawShrapIcon,
  win: Win,
  zoomIn: ZoomInIcon,
} as const;

export type IconName = keyof typeof ComponentMapping;

export interface IIconProps
  extends Pick<IconProps, "className" | "color" | "sx"> {
  name: IconName;
  onClick?: MouseEventHandler<SVGSVGElement>;
}
